import axios from 'axios'
import { getProfilesMock } from './_mocks/profile'
const MOCKED = true

export const getProfiles = async () => (MOCKED ? await getProfilesMock() : await axios.get(''))
